import { apiUrl } from "../constants/global";
import axios from "axios";

async function registerUser(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const { data: response } = await axios.post(
      apiUrl + "v2/register",
      payload,
      config
    );
    return response;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    else if (error.request) {
      return {
        success: false,
        message: "Network Error",
        data: ["Unable to connect to server. Please check your internet connection."]
      };
    }
    else {
      return {
        success: false,
        message: "Request Error",
        data: [error.message || "An unexpected error occurred."]
      };
    }
  }
}

export default registerUser;